module.exports = __webpack_public_path__ + "static/media/laugh@3x.be100d68.png";